






































































































































































































































































































import {
  Component,
  ProvideReactive,
  Watch,
  mixins,
} from 'nuxt-property-decorator'
import { mapState } from 'vuex'
import {
  getLotAditionalPhotos,
  getParcelIdsByType,
  getConsumerMapHomesites,
  getProject,
  getModels,
  getConsumerMapHomes,
} from '~/api/consumer_map.api'
import Lot from '~/models/lot'
import {
  Amenity,
  AmenityResponse,
  CategoryResponse,
  LegacyAmenity,
  LotInfo,
  LotInfoResponse,
} from '~/models'
import PagedResponse from '~/models/pagedResponse'
import { PublicProject } from '~/models/project'
import { setScrollOnBottomEvent } from '~/utils/scroll'
import Card from '~/components/consumer_map/Card.vue'
import InfoCard from '~/components/consumer_map/InfoCard.vue'
import SideModal from '~/components/consumer_map/SideModal.vue'
import Map from '~/components/consumer_map/Map.vue'
import NotFound from '~/components/consumer_map/NotFound.vue'
import MapFilter from '~/components/consumer_map/map_filters.vue'
import debounce from '~/utils/debounce'
import MobileCard from '~/components/consumer_map/MobileCard.vue'
import MobileCardAmenity from '~/components/consumer_map/MobileCardAmenity.vue'
import projectConfig from '~/assets/project-config.json'
import globalStyling from '~/mixins/globalStyling'
import {
  getAllAmenities,
  getLegacyXOAmenities,
  getPoiCategories,
} from '~/api/amenity.api'
import { MapSidebarTabs } from '~/enums/map'
import { LotTypes } from '~/enums/lots'
import { getConsumerMapProperty } from '~/api/sales_map.api'
import { consumerMapStore, projectStore } from '~/store'
import { Events } from '~/utils/eventLayers'

@Component({
  layout: 'mapView',
  components: {
    Card,
    InfoCard,
    SideModal,
    Map,
    MapFilter,
    NotFound,
    MobileCard,
    MobileCardAmenity,
  },
  mixins: [globalStyling],
  computed: {
    ...mapState('consumer-map', {
      parentPageBaseURL: 'parentPageBaseURL',
    }),
  },
})
export default class ConsumerMap extends mixins(globalStyling) {
  project: PublicProject = null
  activeView: 'map' | 'grid' = 'map'
  activeTab: string = 'homes'
  lotInfo: LotInfo = null
  amenity: Object = null
  homes: LotInfo[] = []
  totalHomes: number = 0
  totalHomeSites: number = 0
  totalHomesFiltered: number = 0
  totalHomeSitesFiltered: number = 0
  homeSites: LotInfo[] = []
  models: Lot[] = null
  propertiesCount: number = 0
  loadingHomesRequestRefCount: number = -1
  loadingHomeSitesRequestRefCount: number = -1

  homesNextPage: number = 1
  homeSitesNextPage: number = 1

  lotsCount: number = 0
  filterParams: any = null
  isMobile: boolean = false
  screenSize: number = window.innerWidth
  cardClicked: boolean = false
  hasLotInfoCardBeenClicked: boolean = false
  hasAmenityCardBeenClicked: boolean = false

  filterVisibilitySettings: Object = {}

  amenities: Amenity[] = []
  amenitiesData: Amenity[] = []
  poisCategories: Array<string> = []
  legacyAmenities: LegacyAmenity[] = []

  debouncedFilteredRequests: Function
  debouncedLoadMoreHomes: Function
  debouncedLoadMoreHomeSites: Function

  mapSidebarTabs: typeof MapSidebarTabs = MapSidebarTabs
  lotsEdges: Array<string> = []
  lotTypes: typeof LotTypes = LotTypes
  summerSeason: boolean = true

  seasonChange(value: boolean) {
    this.summerSeason = value
  }

  @ProvideReactive() loSidebarHover: any = null

  selectedLot: any = ''

  async created(): Promise<void> {
    consumerMapStore.setLotInfo(null)
    consumerMapStore.setParentPageBaseURL()
    try {
      await this.loadProject()
      this.initConfig()
    } catch (exception: any) {
      this.$toast.error(exception)
    }
  }

  setScrollOnBottomEvents(): void {
    setScrollOnBottomEvent(() => {
      this.debouncedLoadMoreHomes()
    }, this.$refs.homesList)

    setScrollOnBottomEvent(() => {
      this.debouncedLoadMoreHomes()
    }, this.$refs.infoHomesList)

    setScrollOnBottomEvent(() => {
      this.debouncedLoadMoreHomeSites()
    }, this.$refs.homeSitesList)

    setScrollOnBottomEvent(() => {
      this.debouncedLoadMoreHomeSites()
    }, this.$refs.infoHomeSitesList)
  }

  async initConfig(): Promise<void> {
    if (
      this.$route.query ||
      Object.keys(this.$route.query).includes('slug') ||
      Object.keys(this.$route.query).includes('parent_page_base_url')
    ) {
      this.getLots()
    }

    this.loadProjectsSpecificStyle(this.$route.params.slug).then(() => {
      this.filterVisibilitySettings = this.getFilterVisibilitySettings
    })

    if (Object.keys(this.$route.query).includes('slug')) {
      let lot = this.getLotBySlug(this.$route.query.slug as string)
      if (!lot) {
        lot = await this.getLotInfoBySlug(this.$route.query.slug as string)
      }
      this.setLotInfo(lot)
    }

    // setting debounce request for load more home and homesites on scroll event in order to avoid repeated calls for the same page
    this.debouncedLoadMoreHomes = debounce(() => {
      if (this.homesNextPage !== 0) {
        this.loadHomes().then((homes) => {
          if (homes && homes.results.length) {
            this.homes = homes.results
          }
        })
      }
    }, 1000)

    this.debouncedLoadMoreHomeSites = debounce(() => {
      if (this.homeSitesNextPage !== 0) {
        this.loadHomeSites().then((homeSites) => {
          if (homeSites && homeSites.results.length) {
            this.homeSites = homeSites.results
          }
        })
      }
    }, 1000)

    if (this.$route?.query) {
      const params: any = this.$route?.query || {}
      consumerMapStore.setCustomQueryParams(params)
    }

    // setting debounce request based on filter selection
    this.debouncedFilteredRequests = debounce(this.requestByFilters, 700)

    // setting scroll on bottom events here to avoid debouncedLoadMoreHomes is not a function error
    this.setScrollOnBottomEvents()

    getModels(this.$route.params.slug)
      .then((res) => {
        this.models = res
      })
      .catch(() => {
        this.$toast.error(
          `Models load failed for ${this.$route.params.slug} project. Try again later.`
        )
        this.models = []
      })

    if (this.project.config.enable_poi_api) {
      this.poisCategories = await this.getPoisCategories()
      await this.loadAmenities({ firstLoad: true })
    }
  }

  get loadingHomes(): boolean {
    return this.loadingHomesRequestRefCount > 0
  }

  get loadingHomeSites(): boolean {
    return this.loadingHomeSitesRequestRefCount > 0
  }

  get isEdgeHighlightEnabled(): boolean {
    if (!this.project || !this.project.config) {
      return false
    }
    return this.project.config.enable_highlight_edges
  }

  get homeTabLabel(): string {
    return projectConfig[this.$route.params.slug]?.homeTabLabel || 'HOMES'
  }

  get homesitesTabLabel(): string {
    return (
      projectConfig[this.$route.params.slug]?.homesitesTabLabel || 'HOME SITES'
    )
  }

  get lots(): Array<LotInfo> {
    return [...this.homes, ...this.homeSites]
  }

  get propertiesShown(): Number {
    return this.totalHomesFiltered + this.totalHomeSitesFiltered || 0
  }

  get getFilterVisibilitySettings(): Object {
    return {
      price: this.isVisible('--ad-cm-filter-price'),
      bedrooms: this.isVisible('--ad-cm-filter-bedrooms'),
      builder: this.isVisible('--ad-cm-filter-builder'),
      sqft: this.isVisible('--ad-cm-filter-sqft'),
      architecture: this.isVisible('--ad-cm-filter-architecture'),
      neighborhood: this.isVisible('--ad-cm-filter-neighborhood'),
      lotAcreage: this.isVisible('--ad-cm-filter-lot-acreage'),
      available: this.isVisible('--ad-cm-filter-available'),
      propertyType: this.isVisible('--ad-cm-filter-property-type'),
    }
  }

  @Watch('totalHomesFiltered')
  @Watch('totalHomeSitesFiltered')
  switchActiveTab() {
    if (!this.totalHomesFiltered && this.totalHomeSitesFiltered !== 0) {
      this.toggleTab('homesites')
    } else {
      this.toggleTab('homes')
    }
  }

  @Watch('activeTab')
  onActiveTabChanged(): void {
    this.getLotsForHighlight()
  }

  async loadProject(): Promise<void> {
    try {
      const response = await getProject(this.$route.params.slug)
      this.project = response
      consumerMapStore.setCurrentProject(response)
      projectStore.setActiveProject({
        id: response.id,
        google_tag_manager_id: response.google_tag_manager_id || null,
      })
    } catch (exception) {
      throw new Error(
        `Error loading project and setting in store: ${exception}`
      )
    }
  }

  private resetPaginationHandling(): void {
    this.homesNextPage = 1
    this.homeSitesNextPage = 1
  }

  async getLots(): Promise<void> {
    const [homes, homeSites] = await Promise.all([
      this.loadHomes({}, true),
      this.loadHomeSites({}, true),
    ])

    this.totalHomes = homes.count
    this.totalHomeSites = homeSites.count

    if (
      this.$route.query ||
      Object.keys(this.$route.query).includes('slug') ||
      Object.keys(this.$route.query).includes('parent_page_base_url')
    ) {
      this.totalHomesFiltered = homes.count
      this.totalHomeSitesFiltered = homeSites.count
      this.homes = homes.results
      this.homeSites = homeSites.results
    }

    this.propertiesCount = homes.count + homeSites.count
    this.resetPaginationHandling()
    this.getLotsForHighlight()
  }

  toggleTab(name: string): void {
    this.activeTab = name
  }

  async getLotsForHighlight(): Promise<void> {
    if (!this.isEdgeHighlightEnabled) {
      return
    }

    const type =
      this.activeTab === MapSidebarTabs.HOMES
        ? LotTypes.HOME
        : LotTypes.HOME_SITE.replace(' ', '')

    const response: any = await getParcelIdsByType(
      type,
      this.project.slug,
      this.filterParams
    )

    this.lotsEdges = response.data || []
  }

  isCondoMasterPlan(): boolean {
    return this.isVisible('--ad-sp-condo-master-plan')
  }

  private async loadHomes(
    params: any = {},
    newRequest: boolean = false
  ): Promise<PagedResponse<LotInfo>> {
    if (!newRequest && this.homesNextPage === 1) {
      this.homesNextPage++
    }

    let output: LotInfoResponse = new LotInfoResponse()

    try {
      if (this.loadingHomesRequestRefCount === -1) {
        this.loadingHomesRequestRefCount = 0
      }
      this.loadingHomesRequestRefCount += 1
      if (this.homesNextPage > 0) {
        const queryParams =
          Object.keys(params).length !== 0 ? params : this.filterParams || {}
        const nextPage = this.homesNextPage ? this.homesNextPage : 0
        const response = await getConsumerMapHomes(
          this.$route.params.slug,
          this.isCondoMasterPlan(),
          {
            ...queryParams,
            page: !newRequest ? nextPage : 1,
          }
        )
        if (!response) {
          throw new Error('Request was cancelled.')
        }
        const homes =
          this.homesNextPage === 1
            ? [...response.results]
            : [...this.homes, ...response.results]

        if (response.next) {
          !newRequest ? this.homesNextPage++ : (this.homesNextPage = 1)
        } else this.homesNextPage = 0

        output = {
          results: homes,
          count: response.count,
          next: response.next,
          previous: response.previous,
        }
      }
    } catch (exception: any) {
      this.handleCancelledRequestException(exception)
    } finally {
      this.loadingHomesRequestRefCount -= 1
      return output
    }
  }

  private async loadHomeSites(
    params: any = {},
    newRequest: boolean = false
  ): Promise<PagedResponse<LotInfo>> {
    if (!newRequest && this.homeSitesNextPage === 1) {
      this.homeSitesNextPage++
    }

    let output: LotInfoResponse = new LotInfoResponse()

    try {
      if (this.loadingHomeSitesRequestRefCount === -1) {
        this.loadingHomeSitesRequestRefCount = 0
      }
      this.loadingHomeSitesRequestRefCount += 1
      if (this.homeSitesNextPage > 0) {
        const queryParams =
          Object.keys(params).length !== 0 ? params : this.filterParams || {}
        const nextPage = this.homeSitesNextPage ? this.homeSitesNextPage : 0
        const response = await getConsumerMapHomesites(
          this.$route.params.slug,
          this.isCondoMasterPlan(),
          {
            ...queryParams,
            page: !newRequest ? nextPage : 1,
          }
        )
        if (!response) {
          throw new Error('Request was cancelled.')
        }
        const homeSites =
          this.homeSitesNextPage === 1
            ? [...response.results]
            : [...this.homeSites, ...response.results]

        if (response.next) {
          !newRequest ? this.homeSitesNextPage++ : (this.homeSitesNextPage = 1)
        } else this.homeSitesNextPage = 0

        output = {
          results: homeSites,
          count: response.count,
          next: response.next,
          previous: response.previous,
        }
      }
    } catch (exception: any) {
      this.handleCancelledRequestException(exception)
    } finally {
      this.loadingHomeSitesRequestRefCount -= 1
      return output
    }
  }

  private handleCancelledRequestException(exception: any) {
    if (!exception) {
      console.log('Request successfully cancelled.')
    } else {
      console.log(exception)
    }
  }

  private requestByFilters(filters: any[]) {
    this.homes = []
    this.homeSites = []
    this.resetPaginationHandling()
    const query: {
      builder?: string
      price?: string
      beds?: string
      style?: string
      neighborhood?: string
      acreage?: string
      move_in_date?: string
      property_type?: string
    } = {}

    const params: any = {}
    filters.forEach((filter) => {
      if (filter?.type === 'price') {
        if (!params.price) {
          params.price = [filter.value.split(',').map((val: string) => +val)]
        } else {
          params.price.push(filter.value.split(',').map((val: string) => +val))
        }
        query.price = params.price
      } else if (filter?.type === 'bedrooms') {
        params.beds = filter.value
        query.beds = params.beds
      } else if (filter?.type === 'builder') {
        if (!params.builder) {
          params.builder = [filter.value]
        } else {
          params.builder.push(filter.value)
        }
        query.builder = params.builder
      } else if (filter?.type === 'arch') {
        if (!params.style) {
          params.style = [filter.value]
        } else {
          params.style.push(filter.value)
        }
        query.style = params.style
      } else if (filter?.type === 'neighborhood') {
        if (!params.neighborhood) {
          params.neighborhood = [filter.value]
        } else {
          params.neighborhood.push(filter.value)
        }
        query.neighborhood = params.neighborhood
      } else if (filter?.type === 'acreage') {
        if (!params.acreage) {
          params.acreage = [filter.value.split(',').map((val: string) => val)]
        } else {
          params.acreage.push(filter.value.split(',').map((val: string) => val))
        }
        query.acreage = params.acreage
      } else if (filter?.type === 'move_in_date') {
        params.move_in_date = filter.value
        query.move_in_date = params.move_in_date
      } else if (filter?.type === 'property_type') {
        if (!params.property_type) {
          params.property_type = [filter.value]
        } else {
          params.property_type.push(filter.value)
        }
        query.property_type = params.property_type
      } else if (filter?.classification === 'custom') {
        if (!params[filter.type]) params[filter.type] = [filter.value]
        else params[filter.type].push(filter.value)
        query[filter.type] = params[filter.type]
      }
    })

    this.filterParams = params
    this.loadHomes(params, true).then((homes) => {
      this.totalHomesFiltered = homes.count
      this.homes = homes.results
    })
    this.loadHomeSites(params, true).then((homesites) => {
      this.totalHomeSitesFiltered = homesites.count
      this.homeSites = homesites.results
    })
    this.$router.push({
      path: this.$route.path,
      query,
    })
    this.resetPaginationHandling()
  }

  async setLotInfo(
    lotInfo: LotInfo,
    type?: string,
    view?: string
  ): Promise<void> {
    if (type && view) {
      Events.lot('lotClick', `click | ${type}`, lotInfo, view)
    }

    this.setIsMobile()

    this.lotInfo = lotInfo
    this.selectedLot = lotInfo

    if (lotInfo) {
      let lotAdditionalPhotos = []
      lotAdditionalPhotos = await this.getAdditionalPhotos(
        lotInfo?.slug as string
      )
      lotInfo.additional_photos = lotAdditionalPhotos
    }
  }

  removeLotInfo() {
    if (this.hasLotInfoCardBeenClicked && !this.cardClicked) {
      this.lotInfo = null
      this.hasLotInfoCardBeenClicked = false
    } else {
      this.hasLotInfoCardBeenClicked = true
    }
  }

  setIsMobile() {
    if (window.innerWidth < 1024) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  }

  handleFilterChange(filters: any[]): void {
    if (!this.debouncedFilteredRequests) {
      this.debouncedFilteredRequests = debounce(this.requestByFilters, 700)
    }
    this.debouncedFilteredRequests(filters)
  }

  mobilecardClick(): void {
    this.cardClicked = true
  }

  onLotListHover(lotInfo?: any): void {
    if (!lotInfo && this.selectedLot) {
      lotInfo = this.selectedLot
    }

    if (!lotInfo) {
      this.loSidebarHover = null
      return
    }

    this.loSidebarHover = {
      centerpoint: lotInfo.centerpoint,
      parcel_id: lotInfo.parcel_id,
    }
  }

  async loadProjectsSpecificStyle(projectId: string) {
    await import(`assets/css/${projectId}.css`)
  }

  async loadAmenities({
    searchText = '',
    category = '',
    firstLoad = false,
  }: {
    searchText?: string
    category?: string
    firstLoad?: boolean
  } = {}): Promise<void> {
    try {
      if (this.project.config.enable_poi_api) {
        if (!searchText && !category && !firstLoad) {
          this.amenitiesData = []
          return
        }
        const pois: AmenityResponse = await getAllAmenities({
          slug: this.$route.params.slug,
          search: searchText,
          category,
        })
        if (firstLoad) {
          this.amenities = this.amenitiesData = pois.items
        } else {
          this.amenitiesData = pois.items
        }
      } else {
        const oldPois = await getLegacyXOAmenities()
        this.legacyAmenities = oldPois.map((poi) => ({ ...poi, legacy: true }))
      }
    } catch (exception) {
      this.amenitiesData = []
      this.amenities = []
      this.legacyAmenities = []
      console.log(exception)
    }
  }

  async performSearch(data: any): Promise<void> {
    try {
      await this.loadAmenities(data)
    } catch (exception) {
      console.log(exception)
    }
  }

  async getPoisCategories(): Promise<Array<string>> {
    try {
      const poisCategories: CategoryResponse = await getPoiCategories({
        slug: this.$route.params.slug,
      })
      const categories = poisCategories.items
      return [...new Set(categories.map((category) => category.name))]
    } catch (error) {
      return []
    }
  }

  setAmenity(amenity: Object) {
    this.setIsMobile()
    this.amenity = amenity
  }

  removeAmenity() {
    if (this.hasAmenityCardBeenClicked) {
      this.amenity = null
      this.hasAmenityCardBeenClicked = false
    } else {
      this.hasAmenityCardBeenClicked = true
    }
  }

  getLotBySlug(slug: string): LotInfo {
    const lots = [...this.homes, ...this.homeSites]

    return lots.find((lot) => lot.slug === slug)
  }

  async getAdditionalPhotos(lotSlug: string): Promise<any> {
    const additionalPhotos = await getLotAditionalPhotos(lotSlug)
    return additionalPhotos
  }

  async getLotInfoBySlug(lotSlug: string): Promise<any> {
    const property = await getConsumerMapProperty(
      this.$route.params.slug,
      lotSlug
    )
    return property
  }
}
